document.addEventListener("DOMContentLoaded", () => {
    function getMaxTabHeight() {
        const tabs = document.querySelectorAll('.slider-bullets__progress .slider-bullets__progress-item');
        let maxHeight = 0;

        tabs.forEach(tab => {
            const prevDisplay = tab.style.display;
            const prevVisibility = tab.style.visibility;
            const prevPosition = tab.style.position;

            tab.style.display = 'flex';
            tab.style.visibility = 'hidden';
            tab.style.position = 'absolute';

            const height = tab.querySelector('.slider-bullets__item-text').offsetHeight;
            if (height > maxHeight) maxHeight = height;

            tab.style.display = prevDisplay;
            tab.style.visibility = prevVisibility;
            tab.style.position = prevPosition;
        });

        return maxHeight;
    }

    function equalizeHeights() {
        const itemTexts = document.querySelectorAll('.slider-bullets__progress-item .slider-bullets__item-text');
        itemTexts.forEach(text => text.style.height = '');
        const height = getMaxTabHeight();
        itemTexts.forEach(text => text.style.height = height + 'px');
    }

    equalizeHeights();
    window.addEventListener('resize', equalizeHeights);

    const tabButtons = document.querySelectorAll('.slider-bullets__tabs .timeline__tabs-item');
    const tabContents = document.querySelectorAll('.slider-bullets__progress .slider-bullets__progress-item, .slider-bullets__media-wrapper .slider-bullets__progress-item');

    if (tabButtons && tabContents) {
        tabButtons.forEach((tabBtn) => {
            tabBtn.addEventListener('click', () => {
                const tabId = tabBtn.dataset.id;

                tabButtons.forEach((btn) => btn.classList.remove('active'));
                tabBtn.classList.add('active');

                tabContents.forEach((content) => {
                    content.classList.remove('active');

                    if (content.dataset.id === tabId) {
                        content.classList.add('active');
                    }
                });
            });
        });
    }
});
